import { defineMessages } from 'react-intl';

export default defineMessages({
    changePaymentMethod: {
        id: 'tdic.billing.billing-summary.Change Payment Method',
        defaultMessage: 'Change Payment Method'
    },
    setPaymentPlan: {
        id: 'tdic.billing.change-bank-account.billing-summary.Setup Payment Plan',
        defaultMessage: 'Setup Payment Plan'
    },
    setupAutomaticPayments: {
        id: 'tdic.billing.change-bank-account.billing-summary.Setup Automatic Payments',
        defaultMessage: 'Setup Automatic Payments'
    }
});
